document.addEventListener('DOMContentLoaded', function () {

  // Subtle scroll reveal
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.1 });
  document.querySelectorAll('.reveal').forEach(el => io.observe(el));

  // Mobile menu drawer
  const menuToggle = document.getElementById('menuToggle');
  const primaryNav = document.querySelector('nav.primary');
  if (menuToggle && primaryNav) {
    menuToggle.addEventListener('click', () => primaryNav.classList.toggle('open'));
    primaryNav.querySelectorAll('a:not(.nav-dropdown-toggle)').forEach(a => {
      a.addEventListener('click', () => primaryNav.classList.remove('open'));
    });

    // Tap anywhere outside the open menu to close it
    document.addEventListener('click', function (e) {
      if (
        primaryNav.classList.contains('open') &&
        !primaryNav.contains(e.target) &&
        !menuToggle.contains(e.target)
      ) {
        primaryNav.classList.remove('open');
      }
    });
  }

  // Nav dropdown (e.g. "About") - on mobile, tap anywhere on the row
  // to expand/collapse, without navigating away. On desktop, clicking
  // still navigates normally (hover already reveals the submenu there).
  document.querySelectorAll('.nav-dropdown-toggle').forEach(function (toggle) {
    toggle.addEventListener('click', function (e) {
      if (window.innerWidth <= 1000) {
        e.preventDefault();
        e.stopPropagation();
        const dropdown = this.closest('.nav-dropdown');
        if (dropdown) dropdown.classList.toggle('open');
      }
    });
  });

  // FAQ accordion
  document.querySelectorAll('.faq-q').forEach(q => {
    q.addEventListener('click', () => q.parentElement.classList.toggle('open'));
  });

  // FAQ private/business toggle
  document.querySelectorAll('.faq-toggle').forEach(group => {
    group.querySelectorAll('button').forEach(btn => {
      btn.addEventListener('click', () => {
        group.querySelectorAll('button').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        const wrap = group.closest('.faq-wrap');
        wrap.querySelectorAll('.faq-panel').forEach(p => p.classList.remove('active'));
        wrap.querySelector('#faq-' + btn.dataset.faq).classList.add('active');
      });
    });
  });

  // Cart line-item quantity change -> resubmit the cart change form
  document.querySelectorAll('.cart-item input[type="number"]').forEach(input => {
    input.addEventListener('change', () => {
      input.closest('form').submit();
    });
  });

  // Disable right-click / long-press context menu on images and videos
  // (a mild deterrent for casual copying only - does not stop bots/scrapers)
  document.addEventListener('contextmenu', function (e) {
    if (e.target.tagName === 'IMG' || e.target.tagName === 'VIDEO') {
      e.preventDefault();
    }
  });

});